<template>
    <v-data-table
        class="white-card"
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :page.sync="page"
        :mobile-breakpoint="0"
        :search="search"
        hide-default-header
        hide-default-footer
    >
        <!-- HEADER -->
        <template v-slot:header="{ props: { headers } }">
            <thead>
            <tr>
                <th v-for="h in headers" :class="`text-${h.align || 'center'}`">
                    {{ h.text }}
                </th>
            </tr>
            </thead>
        </template>

        <!-- BODY -->
        <template v-slot:body="{ items, headers }">
            <tr v-if="loading || items.length === 0">
                <td :colspan="headers.length" class="text-center subheader-light py-5">
                    {{ loading ? 'Cargando...' : 'Sin datos disponibles' }}
                </td>
            </tr>
            <tbody v-else>
            <tr v-for="item in items" :key="item.id">
                <td v-for="h in headers">
                    <div v-if="h.value === 'buttons'" :class="`text-${h.align || 'center'}`">
                        <v-btn v-for="button in h.buttons" :key="button.value"
                               depressed class="mb-1 mr-1" icon
                               :color="button.color" @click="$emit(`click:${button.value}`,item)">
                            <v-icon>{{ button.icon }}</v-icon>
                        </v-btn>
                    </div>
                    <v-btn v-else-if="h.value === 'actions'" depressed :class="`text-${h.align || 'center'} normal-btn`" color="primary"
                           @click="onCLickButton(item)">
                        {{ actionText }}
                    </v-btn>
                    <div v-else-if="h.type === 'link'" :class="`text-${h.align || 'center'}`">
                        <a v-if="item[h.value]" :href="`https://${item[h.value]}`" target="_blank">
                            {{ item[h.value] }}
                            <v-icon color="primary" size="12">mdi-open-in-new</v-icon>
                        </a>
                        <div v-else>
                            -
                        </div>
                    </div>
                    <div v-else :class="`text-${h.align || 'center'}`">
                        {{ getText(item[h.value], h.type) }}
                    </div>
                </td>
            </tr>
            </tbody>
        </template>

        <!-- FOOTER -->
        <template v-slot:footer v-if="pageCount > 0 && !hideFooter">
            <div style="height: 75px;">
                <div class="float-right">
                    <v-pagination
                        v-model="page"
                        class="mt-4 mr-4"
                        :length="pageCount"
                        :total-visible="totalVisible"
                    ></v-pagination>
                </div>
            </div>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "KimsaDataTable",
    props: {
        headers: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        itemsPerPage: {
            type: [Number, String],
            default: 10,
        },
        totalVisible: {
            type: [Number, String],
            default: 5,
        },
        actionText: {
            type: String,
            default: 'Detalle',
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        search: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
        }
    },
    methods: {
        onCLickButton(item) {
            const vm = this
            vm.$emit('action', item.id)
        },
        getText(value, type) {
            switch (type) {
                case 'boolean':
                    return value ? 'Si' : 'No'
                case 'number':
                    return this.$options.filters.number(value) || 0
                case 'money':
                    return `$${this.$options.filters.number(value) || 0}`
                case 'rut':
                    return `${this.$options.filters.rutificador(value)}`
                case 'discount':
                    return `-${value}%`
                case 'percent':
                    return `${value}%`
                case 'phone':
                    return `${this.phoneCode}${value}`
                default:
                    return value
            }
        }
    }
}
</script>

<style scoped>

>>> table th {
    border-bottom: 1px solid #8BC53F !important;
    color: var(--v-primary-base) !important;
}

>>> table th:first-child {
    text-align: start !important;
}

>>> table td {
    border-bottom: 1px solid #E2F0CF !important;
    color: var(--v-primary-base) !important;
}

>>> .v-pagination__item {
    box-shadow: none;
}

>>> .v-pagination__navigation {
    box-shadow: none;
}

>>> .v-pagination__navigation .v-icon {
    color: var(--v-primary-base) !important;
}

</style>